var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, action, reaction, runInAction } from 'mobx';
import http, { Q } from '@http';
import { debounce } from "lodash-es";
import StepStore from './step';
import { cookie } from '@common/utils/storage';
import { AbFeatures } from '@common/utils/abFeature';
import RescheduleStore from './reschedule';
var CreateProcareStore = /** @class */ (function () {
    function CreateProcareStore() {
        var _this = this;
        this.loadingPredict = false;
        this.serviceSearchText = '';
        // if the result has no data, the item with Not in the list? should show.
        this.serviceSearchTextNoData = false;
        this.changeServiceSearchText = function (text) {
            _this.serviceSearchText = text;
        };
        this.predictServiceResult = [];
        this.showAllCategory = false;
        this.allCategoryList = [];
        this.onNotInList = function () { return __awaiter(_this, void 0, void 0, function () {
            var allCategoryList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.serviceSearchText = '';
                        this.showAllCategory = true;
                        this.allCategoryList.length = 0;
                        return [4 /*yield*/, this.api.getAllServiceCategory()];
                    case 1:
                        allCategoryList = _a.sent();
                        runInAction(function () {
                            _this.allCategoryList = allCategoryList;
                            _this.stepStore.toStep(1);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.getAllServiceCategory = function () { return __awaiter(_this, void 0, void 0, function () {
            var allCategoryList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.allCategoryList.length = 0;
                        return [4 /*yield*/, this.api.getAllServiceCategory()];
                    case 1:
                        allCategoryList = _a.sent();
                        runInAction(function () {
                            _this.allCategoryList = allCategoryList;
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.procareDetail = null;
        this.phoneNumber = '';
        this.getProCareDetail = function () { return __awaiter(_this, void 0, void 0, function () {
            var detail;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.rspGetProcareProject()];
                    case 1:
                        detail = _a.sent();
                        runInAction(function () {
                            _this.procareDetail = detail;
                            _this.rescheduleStore.getCanChangeTechnician(detail.Id);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.getPhoneNumber = function () { return __awaiter(_this, void 0, void 0, function () {
            var number;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getPhoneNumber()];
                    case 1:
                        number = _a.sent();
                        runInAction(function () {
                            _this.phoneNumber = number;
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.isLastVersionAutoSchedule = undefined;
        this.api = {
            getPredictService: function (serviceSearchText) {
                return Q(http.post('/RSP/NewRequest/GetPredictService', { value: serviceSearchText }));
            },
            getAllServiceCategory: function () {
                return Q(http.post('/RSP/NewRequest/allServiceCategory'));
            },
            rspGetProcareProject: function () {
                return Q(http.get('RSP/ProCare/GetProcareProject'));
            },
            getPhoneNumber: function () {
                return Q(http.post('/RSP/Dashboard/GetCallCenter'));
            },
            hasVisitAndScheduleCalendarAbmodule: function (locationId) {
                return Q(http.post("/abmodule/hasabmodulepermissionByLocation", {
                    locationId: locationId,
                    abmodule: AbFeatures.VisitDrivenAndScheduleCalendar
                }));
            },
        };
        this.initReactions();
        this.stepStore = new StepStore(this);
        this.rescheduleStore = new RescheduleStore(this);
    }
    CreateProcareStore.prototype.initReactions = function () {
        var _this = this;
        var serviceSearchTextReaction = function () { return (_this.serviceSearchText); };
        var callback = function (serviceSearchText) { return __awaiter(_this, void 0, void 0, function () {
            var result_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(serviceSearchText.length > 0)) return [3 /*break*/, 2];
                        runInAction(function () {
                            _this.loadingPredict = true;
                            _this.serviceSearchTextNoData = false;
                        });
                        return [4 /*yield*/, this.api.getPredictService(serviceSearchText)];
                    case 1:
                        result_1 = _a.sent();
                        runInAction(function () {
                            _this.loadingPredict = false;
                            _this.predictServiceResult = result_1.predictservice;
                            if (result_1.predictservice.length === 0) {
                                _this.serviceSearchTextNoData = true;
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        runInAction(function () {
                            _this.serviceSearchTextNoData = false;
                            _this.predictServiceResult.length = 0;
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        reaction(serviceSearchTextReaction, debounce(callback, 300));
    };
    CreateProcareStore.prototype.getisLastVersionAutoSchedule = function () {
        var _this = this;
        var locationId = cookie("locationId");
        if (!locationId)
            return;
        this.api.hasVisitAndScheduleCalendarAbmodule(locationId).then(function (hasVisitAndScheduleCalendarAbmodule) {
            runInAction(function () {
                _this.isLastVersionAutoSchedule = hasVisitAndScheduleCalendarAbmodule;
            });
        });
    };
    __decorate([
        observable
    ], CreateProcareStore.prototype, "loadingPredict", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "serviceSearchText", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "serviceSearchTextNoData", void 0);
    __decorate([
        action
    ], CreateProcareStore.prototype, "changeServiceSearchText", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "predictServiceResult", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "showAllCategory", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "allCategoryList", void 0);
    __decorate([
        action
    ], CreateProcareStore.prototype, "onNotInList", void 0);
    __decorate([
        action
    ], CreateProcareStore.prototype, "getAllServiceCategory", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "procareDetail", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "phoneNumber", void 0);
    __decorate([
        action
    ], CreateProcareStore.prototype, "getProCareDetail", void 0);
    __decorate([
        action
    ], CreateProcareStore.prototype, "getPhoneNumber", void 0);
    __decorate([
        observable
    ], CreateProcareStore.prototype, "isLastVersionAutoSchedule", void 0);
    __decorate([
        action.bound
    ], CreateProcareStore.prototype, "getisLastVersionAutoSchedule", null);
    return CreateProcareStore;
}());
export default CreateProcareStore;
